import { css, theme } from "@vitality-ds/system";
export default css({
  margin: "unset",
  position: "relative",
  "& > div": {
    height: theme.fontSizes.caption.value,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});